import React from 'react';

interface WarningMessProps {
  warning: string;
}

const WarningMess: React.FC<WarningMessProps> = ({ warning }) => {
  return (
    <div className=' font-semibold mb-1'>
      <p className='text-[#C2410C] bg-[#FFEDD5] py-4 pl-7 '>{warning}</p>
    </div>
  );
};

export default WarningMess;
